import { authentication } from '@microsoft/teams-js';

import { AcquireTokenAuthError } from '../errors';

import { ensureInitialized } from './initialize';

interface GetAuthTokenOptions {
  readonly resource: string;
  readonly claims?: string[];
  readonly tenantId?: string;
  readonly silent?: boolean;
}
type GetAuthToken = (options: GetAuthTokenOptions) => Promise<string>;
export const getAuthToken: GetAuthToken = async ({ resource, claims, tenantId, silent }) => {
  await ensureInitialized();

  return authentication
    .getAuthToken({
      resources: [resource],
      claims,
      tenantId,
      silent,
    })
    .catch((error: string) => {
      throw new AcquireTokenAuthError({ errorCode: 'AuthAcquireTokenFailed', errorMessage: error });
    });
};
